import { useTheme } from '@material-ui/core';
import { designTokens } from './Theme.design-tokens';
var _designTokens$colors = designTokens.colors,
    lightEmphasisLow = _designTokens$colors.lightEmphasisLow,
    lightEmphasisMedium = _designTokens$colors.lightEmphasisMedium,
    lightEmphasisHigh = _designTokens$colors.lightEmphasisHigh,
    darkEmphasisLow = _designTokens$colors.darkEmphasisLow,
    darkEmphasisMedium = _designTokens$colors.darkEmphasisMedium,
    darkEmphasisHigh = _designTokens$colors.darkEmphasisHigh,
    lightContextLow = _designTokens$colors.lightContextLow,
    lightContextMedium = _designTokens$colors.lightContextMedium,
    lightContextHigh = _designTokens$colors.lightContextHigh,
    darkContextLow = _designTokens$colors.darkContextLow,
    darkContextMedium = _designTokens$colors.darkContextMedium,
    darkContextHigh = _designTokens$colors.darkContextHigh;

var getEmphasis = function getEmphasis(paletteType) {
  var isLight = paletteType === 'light';
  return {
    low: isLight ? lightEmphasisLow : darkEmphasisLow,
    medium: isLight ? lightEmphasisMedium : darkEmphasisMedium,
    high: isLight ? lightEmphasisHigh : darkEmphasisHigh,
    contextLow: isLight ? lightContextLow : darkContextLow,
    contextMedium: isLight ? lightContextMedium : darkContextMedium,
    contextHigh: isLight ? lightContextHigh : darkContextHigh
  };
};

export var useEmphasis = function useEmphasis() {
  var _useTheme = useTheme(),
      type = _useTheme.palette.type;

  return getEmphasis(type);
};
//# sourceMappingURL=utils.js.map